import type { AdminAuthUser, TokenPair } from '@/types/admin.types';
import { tokenManager } from '@/utils/token-manager';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminAuthState {
  user: AdminAuthUser | null;
  tokens: TokenPair | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

interface AdminAuthActions {
  setUser: (user: AdminAuthUser | null) => void;
  setTokens: (tokens: TokenPair | null) => void;
  setLoading: (isLoading: boolean) => void;
  logout: () => void;
}

export const useAdminAuthStore = create<AdminAuthState & AdminAuthActions>()(
  persist(
    (set) => ({
      user: null,
      tokens: null,
      isAuthenticated: false,
      isLoading: false,

      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setTokens: (tokens) => set({ tokens }),
      setLoading: (isLoading) => set({ isLoading }),
      logout: () => {
        tokenManager.clearTokens();
        set({ user: null, tokens: null, isAuthenticated: false });
      },
    }),
    {
      name: 'admin-auth-storage',
      partialize: (state) => ({
        user: state.user,
        tokens: state.tokens,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
